// extracted by mini-css-extract-plugin
export var addressFields = "_p0-0";
export var animationContainer = "_p0-1";
export var footer = "_p0-2";
export var lineItems = "_p0-3";
export var modalContent = "_p0-4";
export var orderName = "_p0-5";
export var strong = "_p0-6";
export var warning = "_p0-7";